import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams, useOutletContext } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { NotificationManager } from "react-notifications";

const fairbanner = require("./../assets/img/fair-banner.png");
const logo = require("./../assets/img/puma-logo.png");
const fairImg = require("./../assets/img/fair-listing.png");
const wishImg = require("./../assets/img/wishlist-icon2.svg").default;

const FairTradeDetails = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const { storeId } = useParams();
  const location = useLocation();

  // Get store context from StoreLayout
  const outletContext = useOutletContext();
  const store = outletContext?.store;
  const isWishlisted = outletContext?.isWishlisted;
  const favouriteId = outletContext?.favouriteId;

  const [allDetails, setAllDetails] = useState();
  const [openModal, setOpenModal] = useState();
  const [loading, setLoading] = useState(true);

  const fetchStoreDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/store/${storeId}`, {

        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.authorisation?.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAllDetails(responseData?.data);
      } else {
        NotificationManager.warning(responseData?.msg);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleAddStore = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/liked-stores`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          // setResponseStatus(responseData?.msg);
          NotificationManager.success(responseData?.msg);
        } else {
          // setResponseStatus(responseData?.msg);
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  const handleRequestPrice = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/request-price`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
            lang: selectedLanguage,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          NotificationManager.success(responseData?.msg);
        } else {
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  useEffect(() => {
    fetchStoreDetails();
  }, []);

  return (
    <div className="fullContainer">
      <div className="categoryDiv productSliderMain topNew tradePrdts">
        <div className="featureDiv productListMain">
          {loading ? (
            <HeadingSkeleton width="200px" height="28px" />
          ) : (
            <h2 className="storeTabHdn">Seasons</h2>
          )}
          <ul className="products responsiveSliderGrid">
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <ProductCardSkeleton key={index} />
              ))
            ) : allDetails?.seasons.length > 0 ? (
              allDetails?.seasons.map((item, index) => (
                <li key={index} className="seasonCard">
                  {/* <Link to={`/stores/${storeId}/products/${item?.id}`} className="viewBtn"> */}
                  <Link to={`/stores/${storeId}/collections/${item?.title}`} className="viewBtn">
                    <img src={IMAGE_URL + item?.image} alt="" className="tradeImg seasonImg" />
                    {/* <div className="fairOverlay">
                      <div className="fairBtns">
                        <Link to={`/stores/${storeId}/products/${item?.id}`} className="viewBtn"> 
                        <Link to={`/stores/${storeId}/${item?.title}`} className="viewBtn">
                          
                        </Link>
                      </div>
                    </div>*/}
                    <div className="seasonInfo">
                      <h4>{item?.title}</h4>
                      {item?.total_items && (
                        <span>{item?.total_items} items</span>
                      )}
                    </div>


                  </Link>
                </li>
              ))
            ) : (
              <span className="noOrderDiv">{langJson?.norecordsfound}</span>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FairTradeDetails;
